/**
 * Client-side preview mode helpers. The server mirror lives in
 * apps/functions/utils/previewMode.js (functions can't import @repo/config);
 * keep the two in sync.
 */

export const PREVIEW_MODE_DOWNLOAD_MESSAGE = 'Downloads are not available in preview mode.';

// Legacy user docs store the flag as a boolean, the string 'true', or the
// checkbox value 'checked'.
const PREVIEW_MODE_VALUES = new Set([true, 'true', 'checked']);

export function isPreviewModeValue(value) {
    return PREVIEW_MODE_VALUES.has(value);
}

/**
 * Whether a `currentUser` store value ({ uid, providerData, systemData })
 * belongs to a preview mode account. `systemData` is the live user doc.
 */
export function isPreviewUser(user) {
    return isPreviewModeValue(user?.systemData?.previewMode);
}
